import * as types from '../mutation-types';
import { service } from '../../api';

const state = {
  services: [],
  categories: [],
};

const getters = {
};

const actions = {
  fetchTTransportServices({ commit }, params) {
    return service.get(params).then(({ data: response }) => {
      commit(types.RECEIVE_TRANSPORT_SERVICES, { data: response.data });
    });
  },
  fetchServicesCategories({ commit }) {
    return service.getCategories().then(({ data: response }) => {
      commit(types.RECEIVE_TRANSPORT_SERVICES_CATEGORIES, response);
    });
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_TRANSPORT_SERVICES](s, data) {
    s.services = data.data;
  },
  [types.RECEIVE_TRANSPORT_SERVICES_CATEGORIES](s, data) {
    s.categories = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/service.js